export const RequiredErrorMessage = 'This field is required';
export const MaxLengthErrorMessage = 'Please limit your entry to ';
export const EmailRegexErrorMessage = 'Please enter a valid email address';
export const PhoneLengthErrorMessage = '10 digits are required';
export const PostalCodeLengthErrorMessage = 'The postal code must contain 6 characters';
export const PostalCodeRegexErrorMessage = 'Incorrect format for postal code';
export const AddressOnlyCharacters = 'Characters are required';
export const PriceRegexErrorMessage = 'Incorrect price';

export const TIMESPAN_OPTIONS = [
  '9am - Noon',
  'Noon - 3pm',
];

export const NUMBERS_KEYCODE_START = 48;
export const NUMBERS_KEYCODE_END = 57;
export const DOT_KEYCODE = 46;
